import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

export default function Tab({ name, value, label, checked, onChange }) {
  return (
    <div className="tabs__tab">
      <input
        className="tab__input"
        type="radio"
        id={value}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <label
        htmlFor={value}
        className="tab__label"
      >
        {label}
        <ViewerPrimaryColorUserStyle domStyle="borderTopColor">
          <div className="tab__label-inidicator" />
        </ViewerPrimaryColorUserStyle>
      </label>
    </div>
  );
}

Tab.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Properties/PropertyWrapper/Tab.js